import { render } from "./CounterComp.vue?vue&type=template&id=64f5a9b8"
import script from "./CounterComp.vue?vue&type=script&lang=js"
export * from "./CounterComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__